import React from "react";
export const OrganizationContext = React.createContext();
